import { InfoDropdownV2, type InfoTableItem } from '@/components/custom/erp';
import { QUERY_KEYS, theKhoColumns } from '@/constants';

interface InfoDropdownProps {
  uuid?: string;
  ma_ct?: string;
  className?: string;
}

const tableItems: InfoTableItem[] = [
  {
    title: 'Xem sổ kho',
    endpoint: QUERY_KEYS.SO_KHO,
    columns: theKhoColumns,
    group: 1
  }
];

export const InfoDropdown = ({ uuid, ma_ct, className }: InfoDropdownProps) => {
  if (!uuid) return null;

  return <InfoDropdownV2 uuid={uuid} ma_ct={ma_ct} tableItems={tableItems} className={className} />;
};

export default InfoDropdown;
